import React from "react";
import { GOOGLE_MAPS_EMBED_SRC, GOOGLE_MAPS_URL } from "../config";

export default function InfoSection() {
  return (
    <section
      id="infos"
      className="min-h-screen flex flex-col items-center justify-center px-4 py-16 relative"
      style={{
        backgroundImage: "url('/Images/Info/Venue_background.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="absolute inset-0 bg-white opacity-40 pointer-events-none"></div>
      <div className="bg-white bg-opacity-80 p-6 rounded-lg z-10">
        <h2 className="small-caps text-4xl font-bold text-center mb-4">Venue</h2>
        <div className="flex items-start">
          <div className="mr-2 text-2xl">📍</div>
          <div className="flex-1 font-display text-justify">
            <p>Island View Garden</p>
            <p>Petit Raffray, Mauritius</p>
          </div>
        </div>
      </div>

      <div className="w-full max-w-4xl mt-8">
        <div className="relative min-h-[50vh]" style={{ paddingBottom: "56.25%", height: 0 }}>
          <iframe
            title="Venue location"
            src={GOOGLE_MAPS_EMBED_SRC}
            className="absolute inset-0 w-full h-full rounded-lg border-0"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
        <p className="text-sm text-gray-600 text-center mt-2">
          <a
            href={GOOGLE_MAPS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="underline text-blue-600 hover:text-blue-800 bg-white bg-opacity-80 p-2 rounded"
          >
            Open in Google Maps with recommendations
          </a>
        </p>
      </div>
    </section>
  );
}
